
import Vue from 'vue';

import * as GlossStore from '@/store/search/form/glossStore';

import SelectPicker from '@/components/SelectPicker.vue'

export default Vue.extend ({
	name: 'GlossQueryField',
	components: { SelectPicker },
	props: {
		fieldDescription: Object as () => GlossStore.GlossFieldDescription
	},
	computed : {
		id(): string {
			return 'gloss-query-field-' + this.fieldDescription.fieldName ;
		},
		currentValue: {
			get(): string { return GlossStore.get.getGlossQueryFieldValue(this.fieldDescription.fieldName); },
			set(v: string) { GlossStore.actions.setOneGlossQueryField({fieldName: this.fieldDescription.fieldName, fieldValue : v }); }
		}
	},
})

